/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dynamic-slide-toggle.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@covalent/dynamic-forms/dynamic-elements/dynamic-slide-toggle/dynamic-slide-toggle.component';
import * as i3 from '../../../../@angular/material/typings/index.ngfactory';
import * as i4 from '@angular/forms';
import * as i5 from '@angular/material';
const styles_TdDynamicSlideToggleComponent:any[] = [i0.styles];
export const RenderType_TdDynamicSlideToggleComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_TdDynamicSlideToggleComponent,data:{}});
export function View_TdDynamicSlideToggleComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),11,'div',[['class',
      'dynamic-slide-toggle-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),8,'md-slide-toggle',[['flex','']],[[1,'required',0],[2,'mat-slide-toggle',
          (null as any)],[2,'mat-checked',(null as any)],[2,'mat-disabled',(null as any)],
          [2,'mat-slide-toggle-label-before',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange']],(_v,en,
          $event) => {
        var ad:boolean = true;
        var _co:i2.TdDynamicSlideToggleComponent = _v.component;
        if (('ngModelChange' === en)) {
          const pd_0:any = ((<any>(_co.value = $event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i3.View_MdSlideToggle_0,i3.RenderType_MdSlideToggle)),i1.ɵdid(16384,(null as any),
      0,i4.RequiredValidator,([] as any[]),{required:[0,'required']},(null as any)),
      i1.ɵprd(1024,(null as any),i4.NG_VALIDATORS,(p0_0:any) => {
        return [p0_0];
      },[i4.RequiredValidator]),i1.ɵdid(1228800,(null as any),0,i5.MdSlideToggle,[i1.ElementRef,
          i1.Renderer2,i5.FocusOriginMonitor],{required:[0,'required']},(null as any)),
      i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i5.MdSlideToggle]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [2,i4.NG_VALIDATORS],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(0,['\n    ',
          '\n  '])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i2.TdDynamicSlideToggleComponent = _v.component;
    const currVal_12:any = _co.required;
    _ck(_v,3,0,currVal_12);
    const currVal_13:any = _co.required;
    _ck(_v,5,0,currVal_13);
    const currVal_14:any = _co.value;
    _ck(_v,7,0,currVal_14);
  },(_ck,_v) => {
    var _co:i2.TdDynamicSlideToggleComponent = _v.component;
    const currVal_0:any = (i1.ɵnov(_v,3).required? '': (null as any));
    const currVal_1:any = true;
    const currVal_2:any = i1.ɵnov(_v,5).checked;
    const currVal_3:any = i1.ɵnov(_v,5).disabled;
    const currVal_4:any = (i1.ɵnov(_v,5).labelPosition == 'before');
    const currVal_5:any = i1.ɵnov(_v,9).ngClassUntouched;
    const currVal_6:any = i1.ɵnov(_v,9).ngClassTouched;
    const currVal_7:any = i1.ɵnov(_v,9).ngClassPristine;
    const currVal_8:any = i1.ɵnov(_v,9).ngClassDirty;
    const currVal_9:any = i1.ɵnov(_v,9).ngClassValid;
    const currVal_10:any = i1.ɵnov(_v,9).ngClassInvalid;
    const currVal_11:any = i1.ɵnov(_v,9).ngClassPending;
    _ck(_v,2,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10,currVal_11]);
    const currVal_15:any = _co.label;
    _ck(_v,10,0,currVal_15);
  });
}
export function View_TdDynamicSlideToggleComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'td-dynamic-slide-toggle',
      ([] as any[]),(null as any),(null as any),(null as any),View_TdDynamicSlideToggleComponent_0,
      RenderType_TdDynamicSlideToggleComponent)),i1.ɵprd(5120,(null as any),i4.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i2.TdDynamicSlideToggleComponent]),i1.ɵdid(49152,(null as any),0,i2.TdDynamicSlideToggleComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const TdDynamicSlideToggleComponentNgFactory:i1.ComponentFactory<i2.TdDynamicSlideToggleComponent> = i1.ɵccf('td-dynamic-slide-toggle',
    i2.TdDynamicSlideToggleComponent,View_TdDynamicSlideToggleComponent_Host_0,{},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/dynamic-forms/dynamic-elements/dynamic-slide-toggle/dynamic-slide-toggle.component.ngfactory.ts